module.exports = __webpack_public_path__ + "img/ojiter.a60a1e3a.svg";